app.controller(
    'ItineraryCorrectionController', ['$scope', '$rootScope', '$http', '$stateParams', '$timeout', 'toastr', '$document', 'Configuration', 'FlaneriesService', 'SideBarService', '$sce', '$translate','HelperService','$window', ItineraryCorrectionController]
);

function ItineraryCorrectionController($scope, $rootScope, $http, $stateParams, $timeout, toastr, $document, Configuration, FlaneriesService, SideBarService, $sce, $translate,HelperService,$window) {
    var vm = this;
    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }

    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }
    $rootScope.CurrentZoneId = vm.ParamZoneId;

    $translate.use($rootScope.LangForInterface);


    vm.ActiveDescription = {};
    vm.ActiveDescriptionId = 0;
    vm.DescriptionToTranslate = {};
    vm.SelectedDescriptionStatusItem = {};
    vm.PreviousDescriptionStatusItem = {};

    vm.ActiveDescriptionVm =
       {
           Clients: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }],
           QualificationList: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }]
       };
    
    //if ($stateParams.lang2) {
    //    $rootScope.LangForTranslationDestination = $stateParams.lang2;
    //}
    //else {
    //    $rootScope.LangForTranslationDestination = '';
    //}
    vm.iti = {
        DescriptionPositionList: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]
    };

    vm.StatusList4WorkflowDescription = ['', '', '', '', '', ''];

    $scope.vm = {};
    $scope.edit = {};
    //strat
    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }
    $translate.use($rootScope.LangForInterface);

 

    var FlaneriesGetSingle = FlaneriesService.getFlaneries($stateParams.id, $stateParams.lang, $rootScope.LangForTranslationDestination, $stateParams.index, $stateParams.sortKey, $stateParams.reverse);
    FlaneriesGetSingle.then(function (t) {
        vm.iti = t.data;
        vm.itiOrigin = angular.copy(vm.iti);

        if (vm.iti.DescriptionList.length > 0) {
            vm.ActiveDescriptionId = 0;
            vm.ActiveDescription = vm.iti.DescriptionList[vm.ActiveDescriptionId];

            //load descriptionVm
            vm.GetDescriptionVm();
        }
       
        $rootScope.Comments = vm.iti.CommentList;
        $rootScope.SideBar = vm.iti.SideBar;
        $rootScope.Clients = vm.iti.ClientList;
        $rootScope.ClassificationList = vm.iti.ClassificationList;
        $rootScope.SideBar.StatusList = vm.iti.StatusList;
        $rootScope.SideBar.CurrentObjectStatus = vm.iti.CurrentItineraryStatus;
        $rootScope.CurrentObjectId = $stateParams.id;
        $rootScope.CurrentPageType = $rootScope.EnumLinkType.Itinerary;
        $rootScope.PlaceList = vm.iti.PlaceList;

        vm.StatusList4WorkflowDescription = angular.copy($rootScope.StatusList4WorkflowDescription);

        //$scope.ChangeZoneById(vm.ParamZoneId);
    },
    function (e) {
        console.log('Chargement du lieu impossible', e);
    });

    //new methodes for iti desc
    vm.UpdateDescription = function () {
        if (vm.ActiveDescriptionVm.Description != undefined) {
            HelperService.UpdateDescription(vm.iti.DescriptionList[vm.ActiveDescriptionId].Description)
                    .then(function (data) {

                    });
        }
    }

    vm.UpdateDescriptionStatus = function () {
        if (vm.ActiveDescriptionVm.Description != undefined) {
            //console.log("test: " +vm.ActiveDescriptionVm.Description.DescriptionId + " : " + $scope.CurrentLang + " : " +vm.ActiveDescriptionVm.DescriptionStatus);
            HelperService.UpdateDescriptionStatus(vm.ActiveDescriptionVm.Description.DescriptionId, $scope.CurrentLang, vm.ActiveDescriptionVm.DescriptionStatus);
        }
    }

    vm.UpdateDescriptionPosition = function () {
        if (vm.ActiveDescriptionVm.Description != undefined) {
            HelperService.UpdateDescriptionPosition(vm.iti.Iti.ItineraryId, vm.ActiveDescriptionVm.Description.DescriptionId, vm.ActiveDescriptionVm.DescriptionCurrentPositionText, vm.ActiveDescriptionVm.DescriptionNewPositionText, $rootScope.EnumLinkType.Itinerary);
        }
    }

    vm.AddDescriptionToClient = function () {
        HelperService.AddDescriptionToClient(vm.ActiveDescriptionVm.Clients, vm.ActiveDescriptionVm.Description.DescriptionId);
    }

    vm.AddQualificationToDescription = function () {
        HelperService.AddQualificationToDescription(vm.ActiveDescriptionVm.QualificationList, vm.ActiveDescriptionVm.Description.DescriptionId);
    }

    vm.GetDescriptionVm = function () {
        HelperService.GetDescriptionVmWithSort(vm.iti.DescriptionList[vm.ActiveDescriptionId].Description.DescriptionId, vm.iti.Iti.ItineraryId, $rootScope.EnumLinkType.Itinerary, 0, $scope.CurrentLang)
            .then(function (desc) {
                vm.ActiveDescriptionVm = desc;
                vm.ActiveDescriptionVmOrigin = angular.copy(vm.ActiveDescriptionVm);
            });
    }

    vm.OpenInOtherLang = function (lang) {
        $window.location.href = $rootScope.interfaceSubFolder + '/#!/correction/walk?id=' + vm.iti.Iti.ItineraryId + "&lang=" + lang + "&index=" + $stateParams.index + "&sortKey=" + $stateParams.sortKey + "&reverse=" + $stateParams.reverse + "&z=" + $stateParams.z;
    }

    vm.PreviousDesc = function () {
        if (vm.iti.DescriptionList.length > 0 && vm.ActiveDescriptionId > 0) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId - 1;
            vm.GetDescriptionVm();
        }
    }

    vm.NextDesc = function () {
        if (vm.iti.DescriptionList.length > 0 && vm.ActiveDescriptionId < vm.iti.DescriptionList.length - 1) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId + 1;
            vm.GetDescriptionVm();
        }
    }

    //those methodes stay unchanged for now, itistep does not have multidesc

    $rootScope.TranslateDescription = function TranslateDescription(index) {
        FlaneriesService.TranslateDescription(vm.iti, $scope.CurrentLang, $rootScope.LangForTranslationDestination, index);
    };

    vm.UpdateItineraryTranslation = function UpdateItineraryTranslation() {
        FlaneriesService.UpdateItineraryTranslation(vm.iti);
    };

    vm.UpdateDescriptionIti = function UpdateDescriptionIti(index) {
        FlaneriesService.UpdateDescriptionIti(index,vm.iti);
    };

    //$scope.UpdateDescriptionStatus = function UpdateDescriptionStatus(status, index) {
    //    vm.iti.DescriptionList[index].Description.StatusId = status;
    //    FlaneriesService.UpdateDescriptionStatusIti(vm.iti,$rootScope.LangForTranslationDestination);
    //};


    // SideBar method
    $rootScope.UpdateObjectStatus = function UpdateObjectStatus(status, objectId) {
        SideBarService.UpdateObjectStatus(status, objectId, $rootScope.LangForTranslationDestination, 15);
    };

    $rootScope.AddComment = function AddComment(CurrentObjectId) {

        promiseAddComment = SideBarService.AddComment($rootScope.vm.SideBar.CommentEdit, $stateParams.id, $rootScope.CurrentLang, 15);

        promiseAddComment
            .then(
                function success(data) {
                    $rootScope.Comments = $rootScope.returnNewComments;
                    $rootScope.SideBar.CommentEdit.Comment = '';
                },
                function error(data) {
                }
            );
    };

    $rootScope.SaveDiffuseur = function SaveDiffuseur() {

        promiseAddComment = SideBarService.SaveDiffuseur($rootScope.vm.iti.ClientList, $stateParams.id, $rootScope.CurrentLang, 15);
    };

    $rootScope.SaveAdressesAssociees = function SaveAdressesAssociees() {

        promiseAddComment = SideBarService.SaveAdressesAssociees($rootScope.vm.iti.PlaceList, $stateParams.id, $rootScope.CurrentLang, 15);
    };

    $rootScope.SaveClassification = function SaveClassification() {

        promiseAddComment = SideBarService.SaveClassification($rootScope.vm.iti.ClassificationList, $stateParams.id, $rootScope.CurrentLang, 15);
    };



    $scope.dropdownDescIsOpen = false;

    $scope.getHtml = function (htmlContent) {
        return $sce.trustAsHtml(htmlContent);
    };

    $scope.updateFieldTags = function () {
        $scope.$emit('updateFieldTags');
    };

   

    $rootScope.refreshHistory = function refreshHistory() {
        var lastelement = $rootScope.SideBar.HistoryList == null ? null : $rootScope.SideBar.HistoryList.shift();
        promiseRefreshHistory = SideBarService.RefreshHistory($rootScope.CurrentObjectId, $stateParams.lang, "Iti", (lastelement == null ? 0 : lastelement.ChangeLogId));
        promiseRefreshHistory
            .then(
                  function success(data) {
                      $rootScope.SideBar.HistoryList = $rootScope.returnNewHistory.concat($rootScope.SideBar.HistoryList);

                  },
                function error(data) {
                });
    };

    $rootScope.shareInfoPratique = function () {
        $rootScope.shareInfoByDefaultMail('emailShareItineraryPracticalInfo', $translate.instant('emailShareItineraryPracticalInfo').replaceAll('&amp;', '&'), $scope.vm);
    }

    $rootScope.shareFicheComplete = function () {
        $rootScope.shareInfoPratique();
    }

};